module.exports = __webpack_public_path__ + "img/car.5636c996.svg";